module.exports = __webpack_public_path__ + "static/artist-development-case-study-7e28e0e3884927c6804eff8c0a7c42f6.webp";